import React, { useState } from 'react';
import { capitalizeFirstLetter } from '~helpers/jstool';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import cls from 'classnames';
import Modal from 'common/components/modal';

const useStyles = makeStyles(theme => ({
  modalWrapper: {
    '& .ant-modal-body': {
      padding: '0 32px',

      '& .ant-descriptions-item-label': {
        padding: '9.25px 17px',
        color: theme.colors.bodyColor,
        backgroundColor: theme.colors.gray3,
      },

      '& .ant-descriptions-item-content': {
        color: theme.colors.bodyColor,
        padding: '9.25px 17px',
      },

      '& .ant-form-item': {
        paddingBottom: 0,
      },

      '& .ant-form-item-label': {
        '& > label': {
          color: 'rgba(0, 0, 0, 0.65) !important',
        },
        fontSize: 14,
        lineHeight: '22px',
        paddingBottom: 8,
      },
    },
  },
  subtitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.85)',
    marginBottom: 16,

    '&::before': {
      content: '""',
      height: 16,
      width: 3,
      backgroundColor: '#38b2a6',
      marginRight: 8,
    },
  },
  hintBox: {
    ...theme.flex.row,
    marginTop: 8,
  },
  box: {
    padding: '12px 24px',
    display: 'flex',
    ...theme.typography.body2,
    ...theme.colors.titleColor,
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: 4,
    marginBottom: 12,
    cursor: 'pointer',
    '& > .ant-radio-wrapper': {
      display: 'flex',
    },
    '.ant-radio': {
      marginTop: '14px',
    },
    '&:hover': {
      border: `1px solid ${theme.colors.mainGreen6}`,
    },
  },
  box_title: {
    ...theme.typography.body2,
    color: theme.colors.titleColor,
    marginBottom: 8,
  },
  active: {
    fontWeight: 600,
  },
  box_content: {
    ...theme.typography.body2,
    color: theme.colors.captionColor,
    whiteSpace: 'normal',
  },
}));

const ListingPlanModal = ({
  landlord,
  showListingPlan,
  handleCancelModal,
  updateLandlord,
  updateCallback,
  updateLandlordLoading,
}) => {
  const listingPlansData = [
    { title: 'List', desc: 'Ideal for landlords with their own property management system.' },
    {
      title: 'Book',
      desc: 'Ideal for property managers who would like to review applications before accepting and receiving payment',
    },
    {
      title: 'Connect',
      desc: 'Ideal for landlords with multiple properties who prefer to accept orders based on real-time inventory availability.',
    },
  ];
  const { t } = useTranslation();
  const classes = useStyles();
  const { listingPlan } = landlord;
  const [selectedIndex, setselectedIndex] = useState(
    listingPlansData.findIndex(ls => ls.title === capitalizeFirstLetter(listingPlan)) ?? 0,
  );

  return (
    <Modal
      visible={showListingPlan}
      width={820}
      title={'Edit Listing Plan'}
      wrapClassName={classes.modalWrapper}
      onCancel={handleCancelModal}
      okText={t('cms.landlord.modal.confirm.button')}
      cancelText={t('cms.landlord.modal.cancel.button')}
      onOk={() => {}}
      okButtonProps={{
        loading: updateLandlordLoading,
      }}
      popconfirmProps={{
        overlayClassName: 'pms-channel__popconfirm',
        disabled: false,
        overlayStyle: { maxWidth: 236 },
        arrowPointAtCenter: true,
        placement: 'top',
        title: 'Confirm to make this change.',
        onConfirm: () => {
          updateLandlord(
            {
              id: landlord.id,
              listingPlan: listingPlansData[selectedIndex].title.toUpperCase(),
            },
            () => {
              handleCancelModal();
              updateCallback();
            },
          );
        },
        okText: 'Yes',
        cancelText: 'Cancel',
      }}
    >
      <div className={classes.box_title}>Listing Plan</div>
      {listingPlansData.map((item, idx) => (
        <div
          className={classes.box}
          key={idx}
          onClick={() => {
            setselectedIndex(idx);
          }}
        >
          <Radio checked={selectedIndex === idx} style={{ marginTop: '4px' }} />
          <div>
            <div className={cls(classes.box_title, selectedIndex === idx && classes.active)}>
              {item.title}
            </div>
            <div className={classes.box_content}>{item.desc}</div>
          </div>
        </div>
      ))}
    </Modal>
  );
};

ListingPlanModal.displayName = 'ListingPlanModal';

export default ListingPlanModal;
